import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/sites/siteActivityDetail/initialState.siteActivityDetail.data';
import {
  fetchSiteActivityDetailsData as fetchSiteActivityDetailsDataAPI,
  fetchEntitlementsbySiteId as fetchEntitlementsbySiteIdAPI,
  updateSiteActivityDetails as updateSiteActivityDetailsAPI,
} from '../../../../apis/siteAPI';
import { handlePending, handleRejection } from '../../../../constants';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';
import { ACTIONS_SITES_SITEACTIVITYDETAIL } from '../../../../constants/actionCreator';

export const fetchSiteActivityDetails = createAsyncThunkWrapper(
  ACTIONS_SITES_SITEACTIVITYDETAIL.FETCH_SITE_ACTIVITY_DETAILS,
  fetchSiteActivityDetailsDataAPI
);

export const fetchEntitlementsbySiteId = createAsyncThunkWrapper(
  ACTIONS_SITES_SITEACTIVITYDETAIL.FETCH_SITE_ACTIVITY_DETAILS_ENTITLEMENTS_BY_SITE_ID,
  fetchEntitlementsbySiteIdAPI
);

export const updateSiteActivityDetails = createAsyncThunkWrapper(
  ACTIONS_SITES_SITEACTIVITYDETAIL.UPDATE_SITE_ACTIVITY_DETAILS,
  updateSiteActivityDetailsAPI
);

const siteActivityDetailSlice = createSlice({
  name: 'siteActivityDetail',
  initialState,
  reducers: {
    setSiteActivityDetailComments: (state, action) => {
      state.siteActivityDetailsComment = action?.payload || '';
    },
    handleApiResponses: (state) => {
      state.apiSuccessResponse = initialState.apiSuccessResponse;
    },
    handleSaveClose: (state, action) => {
      state.isSaveAndClose = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSiteActivityDetails.pending, (state, action) => {
        handlePending(state, action);
        state.loading = true;
        state.siteActivityDetailsData = [];  
        state.siteEntitlementsData = [];   
        state.siteEntitlementsTotalRecords = 0;   
        state.apiSuccessResponse.getSiteActivityDetail = false;
        state.apiSuccessResponse.updateSiteActivityDetails = false;
      })
      .addCase(fetchSiteActivityDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.siteActivityDetailsData = action?.payload || [];
        state.siteActivityDetailsComment = action?.payload?.comment || '';
        state.apiSuccessResponse.getSiteActivityDetail =
          action.payload?.length === 0 ? 'error' : 'success';
      })
      .addCase(fetchSiteActivityDetails.rejected, (state, action) => {
        handleRejection(state, action);
        state.loading = false;
        state.apiSuccessResponse.getSiteActivityDetail = 'error';
        if (state.apiSuccessResponse.getSiteActivityDetail == 'error') {
          state.siteActivityDetailsData = [];
        }
      })
      
      .addCase(fetchEntitlementsbySiteId.pending, (state, action) => {
        handlePending(state, action);
        state.loading = true;
        state.siteEntitlementsData = [];
        state.siteEntitlementsTotalRecords = 0;
        state.isSiteEntitlementsFound = null;
      })
      .addCase(fetchEntitlementsbySiteId.fulfilled, (state, action) => {
        state.loading = false;
        state.siteEntitlementsData = action?.payload || [];
        state.siteEntitlementsTotalRecords = action?.payload? action.payload[0].totalRecords : 0;
        state.isSiteEntitlementsFound = action?.payload?.length === 0;
      })
      .addCase(fetchEntitlementsbySiteId.rejected, (state, action) => {
        handleRejection(state, action);
        state.loading = false;
        state.siteEntitlementsData = [];
        state.siteEntitlementsTotalRecords = 0;
        state.isSiteEntitlementsFound = true;
      })
      
      .addCase(updateSiteActivityDetails.pending, (state, action) => {
        handlePending(state, action);
        state.loading = true;
        state.isSiteActivityDetailsUpdated = true;
        state.apiSuccessResponse.updateSiteActivityDetails = false;
      })
      .addCase(updateSiteActivityDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.isSiteActivityDetailsUpdated = false;
        state.siteActivityDetailsComment = action?.payload?.comment || '';
        state.apiSuccessResponse.updateSiteActivityDetails = action.payload?.length === 0 ? 'error' : 'success';
      })
      .addCase(updateSiteActivityDetails.rejected, (state, action) => {
        handleRejection(state, action);
        state.loading = false;
        state.isSiteActivityDetailsUpdated = false;
        state.apiSuccessResponse.updateSiteActivityDetails = 'error';
      });
  },
});

export const {
  setSiteActivityDetailComments,
  handleApiResponses,
  handleSaveClose,
} = siteActivityDetailSlice.actions;

export default siteActivityDetailSlice.reducer;
